import React, { useCallback } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import useLogout from "../../../hooks/useLogout";
import { MFA_LOGIN_V2 } from "../../../config/featureFlags";
import SecuritySettings from "./SecuritySettings";

const SecuritySettingsPage = () => {
  const logout = useLogout();
  const location = useLocation();
  const navigate = useNavigate();
  // The nudge's "Set up now" sends { startSetup: true }; it is consumed once so a reload does not restart setup.
  // With the SMS choice it sends "totp" | "sms" (docs/specs/sms-factor.md §1); "sms" opens nothing until plan phase 4.
  const handled = useCallback(
    () => navigate(location.pathname, { replace: true, state: null }),
    [navigate, location.pathname],
  );
  // Flag off: old-login sessions cannot use this page, so a typed URL goes back to My Profile.
  if (!MFA_LOGIN_V2) return <Navigate to="/manage-account" replace />;
  return <SecuritySettings onSignInAgain={logout} startSetup={[true, "totp"].includes(location.state?.startSetup)} onStartSetupHandled={handled} />;
};

export default SecuritySettingsPage;
